<!-- Backdrop -->
<div
  class="fixed z-30 left-0 top-0 w-full h-full bg-black/50 transition-opacity"
  [class.opacity-0]="!healthSystem.isOpen()"
  [class.pointer-events-none]="!healthSystem.isOpen()"
  aria-hidden="true"
  (click)="healthSystem.close()"
></div>

<!-- Modal panel -->
<div
  class="flex justify-center items-center fixed mx-auto z-50 inset-0 py-6 xs:px-2 transition-opacity"
  [class.opacity-0]="!healthSystem.isOpen()"
  [class.pointer-events-none]="!healthSystem.isOpen()"
>
  <div
    class="overflow-auto z-20 relative h-auto w-fit max-h-full bg-white rounded-lg shadow-lg"
  >
    <button
      (click)="healthSystem.close()"
      class="absolute top-4 right-4 text-walden-500 hover:text-gray-700 transition-colors"
      aria-label="Close"
    >
      <wu-icon name="recordsRegCloseIcon"></wu-icon>
    </button>
    <div class="p-8">
      <div embedMicroapp appName="health-system-dashboard-microapp"></div>
    </div>
  </div>
</div>
